import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import { Phone, Mail, Briefcase, UserCheck } from "lucide-react";

/* The four desks a student might need, in one place.
   Exported because the student dashboard's left rail renders the same
   four in its own narrow card (StudentDashboard2.jsx) — two copies of
   these numbers would drift the moment one desk changes. The card
   below, which HelpCenter.jsx also renders, maps over the same list. */
export const CONTACTS = [
  {
    key: "crm",
    label: "CRM Support",
    tel: "02048553350",
    telHref: "tel:02048553350",
    email: "crm@sevenmentor.com",
    icon: Phone,
    color: "#1976d2",
    tint: "#e3f2fd",
  },
  {
    key: "admission",
    label: "Admission Request",
    tel: "+91 77980 58777",
    telHref: "tel:+917798058777",
    email: "registration@sevenmentor.com",
    icon: Mail,
    color: "#388e3c",
    tint: "#e8f5e9",
  },
  {
    key: "jobs",
    label: "Job Opportunities",
    tel: "+91 83290 14018",
    telHref: "tel:+918329014018",
    email: "careers@sevenmentor.com",
    icon: Briefcase,
    color: "#fb8c00",
    tint: "#fff3e0",
  },
  {
    key: "placement",
    label: "Placement Support",
    tel: "02048556661",
    telHref: "tel:02048556661",
    email: "placement@sevenmentor.com",
    icon: UserCheck,
    color: "#8e24aa",
    tint: "#f3e5f5",
  },
];

const ContactInfo = () => {
  return (
    <Card className="border-0 shadow-sm" style={{ borderRadius: "10px" }}>
      <Card.Body>
        <Row className="g-3">
          {CONTACTS.map(({ key, label, tel, telHref, email, icon: Icon, color, tint }) => (
            <Col xs={12} sm={6} lg={3} key={key}>
              <div className="d-flex align-items-start">
                <div className="me-3 p-2 rounded" style={{ backgroundColor: tint }}>
                  <Icon size={20} color={color} />
                </div>
                <div>
                  <h6 className="mb-1" style={{ color }}>{label}</h6>
                  <a href={telHref} className="d-block mb-1 small text-decoration-none text-dark">
                    {tel}
                  </a>
                  <a
                    href={`mailto:${email}`}
                    className="d-block small text-decoration-none text-dark"
                  >
                    {email}
                  </a>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Card.Body>
    </Card>
  );
};

export default ContactInfo;
